/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Poster_AltInputs */

const en_wc_on_poster_alt = /** @type {(inputs: Wc_On_Poster_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft File menu with blank document and template options`)
};

/**
* | output |
* | --- |
* | "WordCraft File menu with blank document and template options" |
*
* @param {Wc_On_Poster_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_poster_alt = /** @type {((inputs?: Wc_On_Poster_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Poster_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_poster_alt(inputs)
});
export { wc_on_poster_alt as "wc.on.poster_alt" }